export const JOB_LIST = [
    {
        ID:1,
        name: "The Pink Panther",
        
        installationStatus:"COMPLETED",

        CustomerID:1,
        TenantID:1,
        
        due:"07/01/2023"
    },
    {
        ID:2,
        name: "The Glasgow Cruiser Minibus",
        
        installationStatus:"COMPLETED",

        CustomerID:8,
        TenantID:2,
        
        due:"10/01/2023"
    },
    {
        ID:3,
        name: "The Toy Box Sport Car",
        
        installationStatus:"COMPLETED",

        CustomerID:3,
        TenantID:3,
        
        due:"15/01/2023"
    },
    {
        ID:4,
        name: "The Newton Mobile for John Newton Motors",
        
        installationStatus:"COMPLETED",

        CustomerID:8,
        TenantID:2,
        
        due:"20/01/2023"
    },
    {
        ID:5,
        name: "The Time Machine, Delorian",
        
        installationStatus:"ASSIGNED",

        CustomerID:3,
        TenantID:3,
        
        due:"26/01/2023"
    },
    {
        ID:6,
        name: "The Mystery Mobile Campervan",
        
        installationStatus:"ASSIGNED",

        CustomerID:3,
        TenantID:3,
        
        due:"30/01/2023"
    },
    {
        ID:7,
        name: "The Teal Titan Transit",
        
        installationStatus:"ASSIGNED",

        CustomerID:7,
        TenantID:7,
        
        due:"03/02/2023"
    },
    {
        ID:8,
        name: "Gary's Dream Porsche",
        
        installationStatus:"UNASSIGNED",

        CustomerID:4,
        TenantID:4,
        
        due:"07/02/2023"
    },
    {
        ID:9,
        name: "The Web Wonder, Computing Solutions",
        
        installationStatus:"UNASSIGNED",

        CustomerID:5,
        TenantID:5,
        
        due:"09/02/2023"
    },
    {
        ID:10,
        name: "The Men's Van's",
        
        installationStatus:"UNASSIGNED",

        CustomerID:6,
        TenantID:6,
        
        due:"15/02/2023"
    },
    {
        ID:11,
        name: "GUHC Team Van (Mens)",
        
        installationStatus:"UNASSIGNED",

        CustomerID:7,
        TenantID:7,
        
        due:"28/02/2023"
    },
    {
        ID:12,
        name: "RLCS IRL Cars 1",
        
        installationStatus:"UNASSIGNED",

        CustomerID:13,
        TenantID:13,
        
        due:"23/04/19"
    },
    {
        ID:13,
        name: "RLCS IRL Cars 2",
        
        installationStatus:"ASSIGNED",

        CustomerID:13,
        TenantID:13,
        
        due:"23/04/19"
    },
    {
        ID:14,
        name: "Glasgow Tour Bus",
        
        installationStatus:"COMPLETED",

        CustomerID:14,
        TenantID:14,
        
        due:"05/05/21"
    },
    {
        ID:15,
        name: "The Presidential Parade for a party limo",
        
        installationStatus:"COMPLETED",

        CustomerID:15,
        TenantID:15,
        
        due:"04/07/2023"
    },
    {
        ID:16,
        name: "Jim's Marvel",
        
        installationStatus:"ASSIGNED",

        CustomerID:16,
        TenantID:16,
        
        due:null,
    },
]